import React from "react";
import "./Error.scss";
import { Link } from "react-router-dom";
import { ReactComponent as SideBtn } from "../../assets/svg/side-btn.svg";

const Error = () => {
  return (
    <section className="section error">
      <article className="error__container container">
        <div className="error__container-contents">
          <code className="flex">Sorry!</code>
          <div className="text flex">
            <h1>404</h1>
            <p>This page could not be found.</p>
          </div>

          <Link to="/" className="aboutCareer__contents-btn">
            <SideBtn />
            <button className="aboutCareer__btn">
              <span>Go back Home</span>
            </button>
          </Link>
        </div>
      </article>
    </section>
  );
};

export default Error;
